import { useState } from "react";
import WizardNavigation from "../WizardNavigation";
import StepHeader from "../StepHeader";

const DIGITAL_OPTIONS = [
  {
    value: "handy",
    label: "Fotos auf Handy",
    description: "QR-Code zum Herunterladen",
  },
  {
    value: "gallery",
    label: "Fotos in Online-Galerie",
    description: "Passwort geschützte Galerie zum Teilen mit Gästen",
  },
  {
    value: "usb",
    label: "Fotos auf USB-Stick",
    description: "Physischer USB-Stick zum Mitnehmen",
  },
];

export default function StepDigital({ value = [], onNext, onBack }) {
  const [localValue, setLocalValue] = useState(value);

  const handleToggle = (option) => {
    const updated = localValue.includes(option)
      ? localValue.filter((e) => e !== option)
      : [...localValue, option];
    setLocalValue(updated);
  };

  const handleNext = () => {
    onNext({ digitalOptions: localValue });
  };

  return (
    <div className="space-y-6">
      <StepHeader
        title="Wie sollen deine Gäste die Fotos erhalten?"
        description="Optional – wähle eine oder mehrere digitale Optionen aus."
      />

      <div className="space-y-3">
        {DIGITAL_OPTIONS.map((option) => (
          <button
            key={option.value}
            onClick={() => handleToggle(option.value)}
            className={`w-full p-4 rounded-lg border-2 transition text-left ${
              localValue.includes(option.value)
                ? "border-[#FF5744] bg-[#FFF4F0]"
                : "border-slate-200 bg-white hover:border-slate-300"
            }`}
          >
            <div className="flex items-start gap-3">
              <div
                className={`w-5 h-5 rounded border-2 flex items-center justify-center flex-shrink-0 mt-0.5 ${
                  localValue.includes(option.value)
                    ? "bg-[#FF5744] border-[#FF5744]"
                    : "border-slate-300"
                }`}
              >
                {localValue.includes(option.value) && (
                  <span className="text-white text-xs">✓</span>
                )}
              </div>
              <div className="flex-1">
                <div className="font-semibold text-slate-900">
                  {option.label}
                </div>
                <div className="text-sm text-slate-600">
                  {option.description}
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>

      <WizardNavigation onBack={onBack} onNext={handleNext} />
    </div>
  );
}
